import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const ScreenAccessPage = lazy(() => import('~/features/organization/pages/screen-access-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/screen-access')({
  beforeLoad: requirePermission('organization_screen_access'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ScreenAccessPage />
    </Suspense>
  ),
});
